
export default function Error() {
    return (
        <div>
            <h1>Oups 🙈 Cette page n'existe pas ou est réservée aux utilisateurs connectés</h1>
        </div>
    )
}